module.exports = __webpack_public_path__ + "static/img/avatar_4.21c6b18.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_4.png
// module id = 1595
// module chunks = 61